var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00621 9.80123C5.00212 9.8507 5 9.90003 5 9.95009V19.05C5 19.5674 5.21447 20.0633 5.59648 20.4286C5.97788 20.7945 6.49561 21 7.03571 21H21.9643C22.5044 21 23.0223 20.7946 23.4035 20.4286C23.7857 20.0633 24 19.5674 24 19.05V9.95009C24 9.90787 23.9986 9.86565 23.9959 9.82401L15.5456 15.3085C14.9009 15.6777 14.0975 15.6764 13.4542 15.3066L5.00621 9.80123ZM5.56194 8.60527L14.1527 14.1919C14.3671 14.3155 14.6352 14.3161 14.8496 14.1926L23.4531 8.62011C23.4369 8.60314 23.4205 8.58689 23.4035 8.57136C23.0223 8.20545 22.5044 8 21.9643 8H7.03575C6.4956 8 5.97791 8.20544 5.59652 8.57136C5.58501 8.58239 5.57349 8.59342 5.56198 8.60517L5.56194 8.60527Z",
    fill: "#898989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.2135c4903328c77ead4fc7a615ad34e4.svg";
export { ForwardRef as ReactComponent };